import { Injectable } from '@angular/core';
// NgRx
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
// RxJs
import { of, switchMap, from } from 'rxjs';
import { catchError, map, startWith } from 'rxjs/operators';

import { MatSnackBar } from '@angular/material/snack-bar';
// Actions
import * as actions from './actions';
// Services
import { PlAccountService } from '../entities/pl-account.service';
import { selectAccount } from './selectors';
import { PlInfoboxComponent } from '../components';

@Injectable()
export class PlAccountEffects {
  constructor(
    private plAccountService: PlAccountService,
    private actions$: Actions,
    private store: Store,
    private snackBar: MatSnackBar
  ) {}

  checkAccountsStatus = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.PLFetchAccounts),
      switchMap(({ accountUuid }) =>
        from(this.plAccountService.getAccount(accountUuid)).pipe(
          map((account) => actions.PLAccountsSuccess({ account })),
          startWith(actions.PLAccountsPending()),
          catchError((error) => of(actions.PLAccountsError({ error })))
        )
      )
    )
  );

  extendDeactivation$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.PLExtendAccountDeactivation),
      concatLatestFrom(() => [this.store.select(selectAccount)]),
      switchMap(([{ accountUuid, date }, account]) =>
        from(this.plAccountService.extendDeactivation(accountUuid, date)).pipe(
          map(() =>
            actions.PLAccountsSuccess({
              account: { ...account, deactivation_date: date },
            })
          ),
          catchError(({ error }) => {
            this.snackBar.openFromComponent(PlInfoboxComponent, {
              data: {
                message:
                  error?.deactivation_date[0] ||
                  'An error occured when extending deactivation date.',
                icon: 'priority_high',
                type: 'error',
              },
            });
            return of();
          })
        )
      )
    )
  );
}
